import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate, useParams } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect, useSyncExternalStore } from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ListaUnidadesMedida } from "../shared/UnidadesMedida";
import { ValidarNum } from "../shared/Regex";

export default function DetalleProducto(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[codigoProducto, setCodigoProducto] = useState("");
    const[descProd, setDescProd] = useState("");
    const[unidad, setUnidad] = useState("NIU");
    //ESTADOS DE CONTENIDO
    //#endregion

    //ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(false);
    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerDatosProducto();
    },[]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(codigoProducto == "" || descProd == ""){
                throw new Error();
            }
            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[codigoProducto, descProd, unidad]);

    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE PARAMS
    // ======================================================================================================
    const navigate = useNavigate();
    const{codProductoActualizar} = useParams();
    //#endregion


    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const HandlerCodigoProducto = (valor) => {
        if(ValidarNum(valor) || valor == ""){
            setCodigoProducto(valor.toUpperCase());
        }
    }
    const HandlerDescProd = (valor) => setDescProd(valor.toUpperCase());
    const HandlerUnidad = (valor) => setUnidad(valor);
    //ESTADOS DE CONTENIDO

    //#endregion

    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerDatosProducto = async () => {
        try{
            const response = await axios.get(URL_DATOS_PRODUCTO,{
                headers: HEADERS_API,
                params: {
                    codigoConsultar: codProductoActualizar
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            const datos = response.data;

            if(datos["descripcion"] == null){
                throw new Error("El producto no existe");
            }

            HandlerDescProd(datos["descripcion"]);
            HandlerCodigoProducto(datos["codigo"]);
            HandlerUnidad(datos["unidad"]);
        }catch(error){
            console.log(error);
            navigate('/productos');
        }
    }
    const EditarProducto = async () => {
        try{
            let response = await axios.put(URL_EDITAR_PRODUCTO, {
                codigoProductoEditar: codProductoActualizar,
                descripcion: descProd,
                unidad: unidad,
                codigo: codigoProducto
            }, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });

            navigate("/productos");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/productos'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                DETALLE DE PRODUCTO
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="codigo-producto">Código del Producto</label>
                    <input onChange={e=>HandlerCodigoProducto(e.target.value)} value={codigoProducto} maxLength={30} type="text" className="form-control text-uppercase" id="codigo-producto" autoComplete="off"/>
                </div>
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="descripcion-producto">Descripción del Producto</label>
                    <input onChange={e=>HandlerDescProd(e.target.value)} value={descProd} maxLength={120} type="text" className="form-control text-uppercase" id="descripcion-producto" autoComplete="off"/>
                </div>                
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label className="form-label fw-semibold" htmlFor="unidad-producto">Unidad de Medida</label>
                    <select onChange={e=>HandlerUnidad(e.target.value)} value={unidad} id="unidad-producto" 
                    className="form-select" placeholder="Unidad de medida">
                        <ListaUnidadesMedida/>
                    </select>
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={EditarProducto} disabled={!datosCompletos} className="btn btn-primary">Guardar Cambios</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_DATOS_PRODUCTO = process.env.REACT_APP_URL_DATOS_PRODUCTO;
const URL_EDITAR_PRODUCTO = process.env.REACT_APP_URL_EDITAR_PRODUCTO;
//#endregion